import {List} from 'immutable';
import isURL from 'validator/lib/isURL';
import isUUID from 'validator/lib/isUUID';
/* oxlint-disable no-underscore-dangle */

export function nonNullValidator(attr, error) {
  const attribute = attr || '';
  if (attribute.length === 0) {
    return List([error]);
  }

  return null;
}

function validUUIDValidator(attr, error) {
  const attribute = attr || '';
  // only validate non-null case IDs
  if (attribute.length && !isUUID(attribute)) {
    return List([error]);
  }
  return null;
}

function validURLValidator(attr, error) {
  const attribute = attr || '';
  if (attribute.length && !isURL(attribute, {require_protocol: true})) {
    return List([error]);
  }
  return null;
}

function validDateRangeValidator(startDate, endDate) {
  // only validate if both dates are filled out
  if (typeof startDate === 'string' && typeof endDate === 'string') {
    if (new Date(startDate) > new Date(endDate)) {
      return ['Invalid date range - start date must come before end date'];
    }
  }

  return null;
}

const StandardSetModelValidators = {
  getTitle() {
    return nonNullValidator(this.getTitle(), 'Standard name Required');
  },

  getDescription() {
    return nonNullValidator(this.getDescription(), 'Standard Description Required');
  },

  getCaseId() {
    return validUUIDValidator(this.getCaseId(), 'Standard set case ID must be a valid UUID');
  },

  getUri() {
    return validURLValidator(this.getUri(), 'Standard set Case URI must be a valid URL');
  },

  getStandardSet() {
    // user is creating a new standard without selecting a standard set
    if (!this.__changeMap.has('__relationshipReplacements') && this.getStandardSet().isEmpty()) {
      return ['Alignment to an existing standard set is requirded'];
    }

    const standardSetReplacements = this.__changeMap.getIn(
      ['__relationshipReplacements', 'standard_set_v1'],
      null
    );

    // this is null when standards field is untouched (editing existing standard)
    if (typeof standardSetReplacements !== 'string') {
      return null;
    }

    return nonNullValidator(
      standardSetReplacements,
      'Alignment to an existing standard set is required'
    );
  },

  getStatusStartDate() {
    return validDateRangeValidator(this.getStatusStartDate(), this.getStatusEndDate());
  },
  getStatusEndDate() {
    return validDateRangeValidator(this.getStatusStartDate(), this.getStatusEndDate());
  }
};

export default StandardSetModelValidators;
